import { ITimeBlockComponentItem } from '../../../types/time-block-component-item-types';
import { CalendarService } from '../../../../../services/calendar.service';
import { TimeBlockStructureService } from '../../../time-block-structure/time-block-structure.service';
import { Slot } from '../slot/slot';
import { TimeBlockIntersectionService } from '../../intersection/time-block-intersection.service';
import { DayOrWeekCalendarModel } from '../../../../../../../core/models/calendar/day-or-week-calendar.model';
import { Injectable, inject } from '@angular/core';
import { SlotHandlerService } from '../../../../../../../core/services/features/fix-interval-planner/slot-handler.service';

@Injectable()
export class ParallelTimeBlockWeekViewFixIntervalCalculatorService {
  private readonly timeBlockStructureService = inject(TimeBlockStructureService);
  private readonly calendarService = inject(CalendarService);
  private readonly timeBlockIntersectionService = inject(TimeBlockIntersectionService);
  private readonly horizontalSlotHandlerService = inject(SlotHandlerService);

  public calculate(): ITimeBlockComponentItem[] {
    const fixIntervalCalendarModel = (this.calendarService.model as DayOrWeekCalendarModel)
      .fixIntervalCalendarModel;
    const visibleTimeBlockMap = this.timeBlockStructureService.getFixIntervalHeadParts(
      fixIntervalCalendarModel.timeBlocks,
    );
    const slots = new Array<Slot>();

    visibleTimeBlockMap.forEach((fixIntervalTimeBlocksPerDay: ITimeBlockComponentItem[]) => {
      this.horizontalSlotHandlerService.orderFixIntervalTimeBlocks(fixIntervalTimeBlocksPerDay);
      fixIntervalTimeBlocksPerDay.forEach((timeBlock: ITimeBlockComponentItem) => {
        this.horizontalSlotHandlerService.assignTimeBlockToSlot(
          timeBlock,
          slots,
          this.timeBlockIntersectionService,
          true,
        );
      });
    });
    (
      this.calendarService.model as DayOrWeekCalendarModel
    ).fixIntervalCalendarModel.highestParallelIndex = slots.length;
    return this.horizontalSlotHandlerService.updateGeometryHorizontalSlots(slots);
  }
}
